import { initializeApp } from 'firebase/app';
import { getFirestore, getDoc, getDocs, collection, doc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getHostName, somethingWentWrong } from './functions';
import axios from 'axios';
import store from '../redux/store';
import { changeLanguage } from '../redux';
// Initialize Firebase
const config = {
  apiKey: "AIzaSyA0woka73VZOVhkejcpyZuTZ16hgLuoAUA",
  authDomain: "menu-online-d025c.firebaseapp.com",
  projectId: "menu-online-d025c",
  storageBucket: "menu-online-d025c.appspot.com",
  messagingSenderId: "241015439518",
  appId: "1:241015439518:web:469cd97556666ff9d7bb8f",
  measurementId: "G-Q7VXH6NJC6"
};
//firebase.firestore().enablePersistence()
const app = initializeApp(config);

const functions = getFunctions(app, 'europe-west3')
if (getHostName().includes("localhost") || getHostName().startsWith("192.168")) {
  console.log("connectFunctionsEmulator")
  connectFunctionsEmulator(functions, "localhost", 5002)
}
const auth = getAuth(app);
auth.useDeviceLanguage();

const firestore = getFirestore(app)
function callFunction(functionname) {
  return httpsCallable(functions, functionname)
}
function getRecaptchaToken(ACTION = "") {
  return Promise.resolve("test-token"); // test modu için sabit token döndür
  const SITE_KEY = '6Lc7XZMqAAAAAOxV4_eE7mic2A4fDg_BxowGYlzR';
   return new Promise((resolve, reject) => {
    if (!window.grecaptcha || !window.grecaptcha.enterprise) {
      return reject(new Error('grecaptcha.enterprise yüklü değil'));
    }
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise
        .execute(SITE_KEY, { action: String(ACTION).replace(/^\//, '').replace(/[^A-Za-z_/]/g, '_') })
        .then(token => resolve(token))
        .catch(err => reject(err));
    });
  });
}
const region = "europe-west1"
const Api = axios.create({
  baseURL: window.location.hostname.includes("localhost") ? 'http://127.0.0.1:5002/menu-online-d025c/'+region+'/api' : "https://menu.restomenum.app/api",
  headers: {
    'Content-Type': 'application/json',
  }
});
Api.interceptors.request.use(
  async (config) => {
    const pathOnly = (config.url || '').split('?')[0];   // örn. "/sendOrder"
    let action = String(pathOnly); // örn. "sendOrder"
    if (action.startsWith("/info")) action = "info";
    const recaptchaToken = await getRecaptchaToken(action);
    config.headers['recaptcha'] = recaptchaToken;
    if (!auth.currentUser) return config; 
    const token = await auth.currentUser?.getIdToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
Api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const getLang = store.getState().language.data;
    if (status === 429) {
      somethingWentWrong(getLang.hata, getLang.tomanyrequest, "warning")
    } else {
      somethingWentWrong(
        getLang.hata,
        getLang.birseyler_ters_gidiyor+" "+error.response?.data+"("+status+")",
        "error"
      );
    }
    return Promise.reject(error);
  }
);
Api.interceptors.response.use(
  (response) => response,                           // başarılıysa geç
  async (error) => {
    const original = error.config;

    // 401 + daha önce denemediysek
    if (
      error.response?.status === 401 &&
      !original._retry &&                          // özel bayrak
      auth.currentUser
    ) {
      original._retry = true;                      // sonsuz döngü engeli
      try {
        // Zorunlu yenileme → getIdToken(true)
        const freshToken = await auth.currentUser.getIdToken(true);
        original.headers.Authorization = `Bearer ${freshToken}`;
        return Api(original);                      // isteği yeniden gönder
      } catch (refreshErr) {
        console.error('Token yenileme başarısız:', refreshErr);
      }
    }
    return Promise.reject(error);
  }
);
const dil = (window.navigator.language).split("-")
for (let index = 0; index < dil.length; index++) {
  const element = dil[index];
  store.dispatch(changeLanguage(element))
}
export {
  auth,
  firestore,
  functions,
  callFunction,
  app,
  getDoc, getDocs, collection, doc,
  Api
}